import React, { Component, PropTypes } from 'react';
import { range, get } from 'lodash';
import * as ReactDOM from 'react-dom';
import classnames from 'classnames';
import {
    defaultProductView,
    splitViewExpandOption,
    defaultSplitViewType,
    roomCategoryExpandOption,
    roomUpsellPriceDisplayTypes,
    roomCategoryViewOption,
    defaultSortSettings,
    inContextRoomCategoryViewOption,
    inContextRoomCategoryExpandOption
} from '../../../constants/configurationListItems';
import { getText } from '../../../../lib/utils';
import { configurationSystemDefault } from '../../../constants/SystemDefaults';
import { ControlledRadioButton as SparkRadioButton } from '../../ui/sabre-spark-react-ex';
import ReactSparkSelectInput from '../../widgets/ReactSparkSelectInput';
import ReactSparkTextInput from '../../widgets/ReactSparkTextInput';
import ConfigurationCheckbox from '../../widgets/ConfigurationCheckbox';
import {
    PRODUCT_LAYOUT_VIEWS,
    ROOM_SETTINGS,
    LAYOUT_VIEW_SETTINGS_LABELS,
    GENERAL,
    layoutSettingsTypeLabelView,
    shoppingCartExpirationDays,
    IN_CONTEXT_PRODUCT_LAYOUT_VIEWS,
    IN_CONTEXT_OVERLAY_WIDTH,
    IN_CONTEXT_DISPLAY_TYPES,
    IN_CONTEXT_ROOM_CATEGORY_MESSAGE,
    inContextNoOfProductsToExpand
} from '../../../constants/RoomsConfiguration';
import ConfigManage from './configurationListSettings/index';
import If from '../../helpers/if';
import InContextBookingStatusControl from './product/InContextBookingStatusControl';
import InContextPositionDistanceControl from './product/InContextPositionDistanceControl';
import InContextResumeBookingButtonHelpContent from './product/InContextResumeBookingButtonHelpContent';
import RoomView from '../../helpers/roomView';
import SidePanel from '../../modals/sidePanel/rightSidePanel';
import InContextHeaderControl from './product/InContextHeaderControl';

class RoomsConfiguration extends Component {
    constructor(props) {
        super(props);
        this.sections = [];
        this.state = {
            activeInfoPanel: 'listDisplayOptions',
            viewSettingsType: 'List',
            productViewRadioButton: this.props.currentConfigCopy.defaultProductView,
            overlayWidthRadioButton: this.props.currentConfigCopy.inContextOverlayWidth || 'fullPage',
            isPanelOpen: false,
            roomAvailabilityDisplayRadioButton: this.props.currentConfigCopy.roomAvailabilityDisplayType || IN_CONTEXT_DISPLAY_TYPES.ROOM_VIEW,
            splitViewRadioButton: this.props.currentConfigCopy.defaultSplitViewType
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.currentConfigCopy.defaultProductView !== this.props.currentConfigCopy.defaultProductView) {
            this.setState({ productViewRadioButton: this.props.currentConfigCopy.defaultProductView });
        }
        if (prevProps.currentConfigCopy.roomAvailabilityDisplayType !== this.props.currentConfigCopy.roomAvailabilityDisplayType) {
            this.setState({ roomAvailabilityDisplayRadioButton: this.props.currentConfigCopy.roomAvailabilityDisplayType });
        }
        if (prevProps.currentConfigCopy.inContextOverlayWidth !== this.props.currentConfigCopy.inContextOverlayWidth) {
            this.setState({ overlayWidthRadioButton: this.props.currentConfigCopy.inContextOverlayWidth });
        }
    }

    capitalize(word) {
        return word[0].toUpperCase() + word.slice(1);
    }

    registerSection(key) {
        return node => (this.sections[key] = node);
    }

    sectionStyleHandler(key) {
        return this.props.searchIndex !== undefined && this.props.searchIndex.indexOf(key) === -1
            ? { display: 'none' }
            : {};
    }

    handleProductViewOnCick(event) {
        const { value } = event.target;
        this.props.setConfigText('defaultProductView', value);
        this.setState({ productViewRadioButton: value });
    }

    handleAvailabilityDisplayTypeOnClick(event) {
        const { value } = event.target;
        this.props.setConfigText('roomAvailabilityDisplayType', value);
        this.setState({ roomAvailabilityDisplayRadioButton: value });
        
        if (value === IN_CONTEXT_DISPLAY_TYPES.CARD_VIEW && this.props.currentConfigCopy.inContextEnableCategoryViews) {
            this.props.toggleConfigBoolean('inContextEnableCategoryViews', true);
            this.props.setConfigText('inContextRoomCategoryViewOption', 'showRoomsSmallSelectableList');
            this.props.setConfigText('inContextRoomCategoryExpandOption', 'expandAll');
            if (this.props.currentConfigCopy.inContextExcludeRoomCategoryImagesFromImageGalleries) {
                this.props.toggleConfigBoolean('inContextExcludeRoomCategoryImagesFromImageGalleries', true);
            }
        }
    }

    handleDefaultSplitViewOnClick(event) {
        const { value } = event.target;
        const defaultView = value.split("-")
        this.props.setConfigText('defaultProductView', defaultView[0]);
        this.props.setConfigText('defaultSplitViewType', defaultView[1]);
        this.setState({ productViewRadioButton: defaultView[0], splitViewRadioButton: defaultView[1] });
    }

    handleEnableCategoryViewsToggle(code, value) {
        this.props.toggleConfigBoolean(code, value);
        
        if (!value) {
            this.props.setConfigText('inContextRoomCategoryViewOption', 'showRoomsGrouping');
        }
    }

    componentDidMount() {
        if (this.props.onIndex) {
            this.sections.forEach((section, key) => {
                this.props.onIndex(getText(ReactDOM.findDOMNode(section)), [key]);
            });
        }
    }

    handleOverlayWidthChange(event) {
        const { value } = event.target;
        this.props.setConfigText('inContextOverlayWidth', value);
        this.setState({ overlayWidthRadioButton: value });
    }

    maxProductsRequested(value) {
        value = parseInt(value);
        if (isNaN(value)) {
            return '';
        }
        return Math.max(Math.min(value, 648), 100);
    }

    handleClickOnInfoIcon(panelType) {
        this.setState(prevState => {
            const isSamePanel = prevState.activeInfoPanel === panelType;
            const shouldClosePanel = prevState.isPanelOpen && isSamePanel;

            return {
                isPanelOpen: !shouldClosePanel,
                activeInfoPanel: panelType
            };
        });
    }

    getSidePanelContent() {
        const isResumeBookingPanel = this.state.activeInfoPanel === 'resumeBookingDistance';
        if (!isResumeBookingPanel) {
            return {
                title: 'List display options',
                introText:
                    'Display options allow you to determine how guests will see your room and rate information in the list view.',
                body: <RoomView />
            };
        }

        return {
            title: <span>Location for <span className="bold-italic">resume booking</span> button</span>,
            body: <InContextResumeBookingButtonHelpContent />
        };
    }

    onCloseSidePanel = () => {
        this.setState({isPanelOpen: false});
    }

    render() {
        const splitViewExpandOptionDefault =
            splitViewExpandOption.find(elem => {
                return elem.key === this.props.currentConfigCopy.splitViewExpandOption;
            }) || splitViewExpandOption[0];
        const roomUpsellPriceDisplayType =
            roomUpsellPriceDisplayTypes.find(elem => {
                return elem.key === this.props.currentConfigCopy.roomUpsellPriceDisplay;
            }) || roomUpsellPriceDisplayTypes[0];
        const defaultSortSetting =
            defaultSortSettings.find(elem => {
                return elem.key === this.props.currentConfigCopy.defaultProductSortSetting;
            }) || defaultSortSettings[0];
        const resumeCartExpirationDaysDefault =
            shoppingCartExpirationDays.find(elem => {
                return elem.key === this.props.currentConfigCopy.shoppingCartExpirationDays;
            }) || _.last(shoppingCartExpirationDays);

        const layoutViewSettingsKey =
            this.state.productViewRadioButton === 'splitView' ? 'roomsAndRates' : 'listAndGrid';

        const layoutViewSettings = [
            {
                key: layoutViewSettingsKey,
                label: `Show Toggle Option Between ${
                    layoutSettingsTypeLabelView[this.state.productViewRadioButton]
                } View`
            },
            { key: 'roomsAndSuites', label: LAYOUT_VIEW_SETTINGS_LABELS.ROOMS_SUITES },
            { key: 'none', label: LAYOUT_VIEW_SETTINGS_LABELS.NO_TOGGLE_OPTION }
        ];
        const defaultValueForLayoutViewSettings =
            layoutViewSettings.find(elem => elem.key === this.props.currentConfigCopy.layoutViewSetting) ||
            layoutViewSettings[0];
        const defaultValueForRoomAvailabilityDisplay =
            inContextNoOfProductsToExpand.find(elem => elem.key === this.props.currentConfigCopy.inContextNoOfProductsToExpand) ||
            inContextNoOfProductsToExpand[0];
        const sidePanelContent = this.getSidePanelContent();

        return (
            <div className="spark-panel__content col-lg-12">
                <SidePanel
                    open={this.state.isPanelOpen}
                    onClose={this.onCloseSidePanel}
                    title={sidePanelContent.title}
                    introText={sidePanelContent.introText}
                    introTextClass={"roomView__intro"}
                    backgroundClickThroughConfig={{
                        enabled: true,
                        shouldIgnoreOutsideClickTarget: target => !!(target && target.closest('.productViewHelpIcon'))
                    }}
                >
                    {sidePanelContent.body}
                </SidePanel>
                <section ref={this.registerSection(0)} style={this.sectionStyleHandler(0)}>
                    <h4>{ROOM_SETTINGS}</h4>
                    <div className={classnames('roomSettingsGeneralContainer', 'spark-panel__content col-lg-12')}>
                        <div className="roomSettingGeneralTitle">{GENERAL}</div>
                        <ConfigurationCheckbox
                            title="Show Only Assigned Rates To Managed Loyalty Program Members"
                            code="showOnlyAssignedRatesToManagedLoyaltyProgramMembers"
                            isDisabled={this.props.isDisabled}
                            onChange={this.props.toggleConfigBoolean}
                            value={this.props.currentConfigCopy.showOnlyAssignedRatesToManagedLoyaltyProgramMembers}
                        />
                        <ConfigurationCheckbox
                            title="Display Member Rates for Expired Memberships"
                            code="displayMemberRatesForExpiredMemberships"
                            isDisabled={this.props.isDisabled}
                            onChange={this.props.toggleConfigBoolean}
                            value={this.props.currentConfigCopy.displayMemberRatesForExpiredMemberships}
                        />
                        <ConfigurationCheckbox
                            title="Display Loyalty Rate for Logged In Users Only"
                            code="hideLoyaltyRatesForNotLoggedInUser"
                            isDisabled={this.props.isDisabled}
                            onChange={this.props.toggleConfigBoolean}
                            value={this.props.currentConfigCopy.hideLoyaltyRatesForNotLoggedInUser}
                        />

                        <ReactSparkSelectInput
                            label="Room Upsell Price Display"
                            isDisabled={this.props.isDisabled}
                            defaultValue={roomUpsellPriceDisplayType.key}
                            values={roomUpsellPriceDisplayTypes.map(v => {
                                return { key: v.key, label: v.label };
                            })}
                            className="roomUpsellPriceDisplay"
                            onChange={event => {
                                const obj = roomUpsellPriceDisplayTypes.find(elem => {
                                    return elem.key === event.target.value;
                                });
                                this.props.setConfigText('roomUpsellPriceDisplay', obj.key);
                            }}
                        />
                        <ReactSparkTextInput
                            label="Maximum # of products to request (100 - 648)"
                            isDisabled={this.props.isDisabled}
                            value={this.props.currentConfigCopy.getProductAvailabilityRequestPageSize}
                            onBlur={event => {
                                const value =
                                    event.target.value ||
                                    configurationSystemDefault.getProductAvailabilityRequestPageSize;
                                this.props.setConfigText(
                                    'getProductAvailabilityRequestPageSize',
                                    this.maxProductsRequested(
                                        value || configurationSystemDefault.getProductAvailabilityRequestPageSize
                                    )
                                );
                            }}
                            onChange={event => {
                                this.props.setConfigText('getProductAvailabilityRequestPageSize', event.target.value)
                            }}
                            type={"number"}
                        />
                        <div className="subHeading">
                            <div>Sort Settings</div>
                            <div> This setting determines how rooms and rates are sorted when guests visit the page
                            </div>
                            <ReactSparkSelectInput
                                label="Sort Products by"
                                isDisabled={this.props.isDisabled}
                                defaultValue={defaultSortSetting.key}
                                values={defaultSortSettings.map(v => {
                                    return { key: v.key, label: v.label };
                                })}
                                onChange={event => {
                                    const obj = defaultSortSettings.find(elem => {
                                        return elem.key === event.target.value;
                                    });
                                    this.props.setConfigText('defaultProductSortSetting', obj.key);
                                }}
                            />
                        </div>
                        <If condition={this.props.inContextBeta}>
                            <div className="subHeading in-context-section">
                                <InContextBookingStatusControl
                                    currentConfigCopy={this.props.currentConfigCopy}
                                    setConfigText={this.props.setConfigText}
                                    isDisabled={this.props.isDisabled}
                                />
                                <hr />
                                <InContextHeaderControl
                                    setConfigText={this.props.setConfigText}
                                    toggleConfigBoolean={this.props.toggleConfigBoolean}
                                    currentConfigCopy={this.props.currentConfigCopy}
                                    isDisabled={this.props.isDisabled} />
                                <hr />
                                <h4 className="subHeading__in">In-context: list display options
                                    <span onClick={() => this.handleClickOnInfoIcon('listDisplayOptions')} className="spark-icon spark-icon-info-circle productViewHelpIcon" />
                                </h4>
                                <div className="defaultProductViewRadioButtonGroup">
                                    <SparkRadioButton
                                        name="in-context-room-view"
                                        value={IN_CONTEXT_DISPLAY_TYPES.ROOM_VIEW}
                                        checked={this.state.roomAvailabilityDisplayRadioButton === IN_CONTEXT_DISPLAY_TYPES.ROOM_VIEW}
                                        onClick={event => this.handleAvailabilityDisplayTypeOnClick(event)}
                                        disabled={this.props.isDisabled}
                                    >
                                        {IN_CONTEXT_PRODUCT_LAYOUT_VIEWS.ROOM_VIEW}
                                    </SparkRadioButton>
                                    <SparkRadioButton
                                        name="in-context-rate-view"
                                        value={IN_CONTEXT_DISPLAY_TYPES.RATE_VIEW}
                                        checked={this.state.roomAvailabilityDisplayRadioButton === IN_CONTEXT_DISPLAY_TYPES.RATE_VIEW}
                                        onClick={event => this.handleAvailabilityDisplayTypeOnClick(event)}
                                        disabled={this.props.isDisabled}
                                    >
                                        {IN_CONTEXT_PRODUCT_LAYOUT_VIEWS.RATE_VIEW}
                                    </SparkRadioButton>
                                    <SparkRadioButton
                                        name="in-context-card-view"
                                        value={IN_CONTEXT_DISPLAY_TYPES.CARD_VIEW}
                                        checked={this.state.roomAvailabilityDisplayRadioButton === IN_CONTEXT_DISPLAY_TYPES.CARD_VIEW}
                                        onClick={event => this.handleAvailabilityDisplayTypeOnClick(event)}
                                        disabled={this.props.isDisabled}
                                    >
                                        {IN_CONTEXT_PRODUCT_LAYOUT_VIEWS.CARD_VIEW}
                                    </SparkRadioButton>
                                </div>
                                <ReactSparkSelectInput
                                    label="Number of products to expand"
                                    isDisabled={this.props.isDisabled}
                                    defaultValue={defaultValueForRoomAvailabilityDisplay.key}
                                    values={inContextNoOfProductsToExpand}
                                    onChange={event => {
                                        this.props.setConfigText('inContextNoOfProductsToExpand', event.target.value);
                                    }}
                                />
                                <p className="spark-message__content status-message px-0">This setting will apply to Room and Rate views, as well as Room and Rate Details pages.</p>
                                <p className="spark-message__content status-message px-0">A minimum of 1 product will be applied to Room and Rate Details pages.</p>
                                <ConfigurationCheckbox
                                    className="top-margin"
                                    title="Show rate image"
                                    isDisabled={this.props.isDisabled}
                                    code="inContextShowRateImage"
                                    onChange={this.props.toggleConfigBoolean}
                                    value={this.props.currentConfigCopy.inContextShowRateImage}
                                />

                                {this.props.currentConfigCopy.roomAvailabilityDisplayType !== IN_CONTEXT_DISPLAY_TYPES.CARD_VIEW && (
                                    <div>
                                        <hr />
                                        <h4 className="top-margin">In-context: room category</h4>
                                        <p className="spark-message__content status-message px-0">{IN_CONTEXT_ROOM_CATEGORY_MESSAGE}</p>
                                        <ConfigurationCheckbox
                                            className="top-margin"
                                            title="Enable category views"
                                            isDisabled={this.props.isDisabled}
                                            code="inContextEnableCategoryViews"
                                            onChange={(code, value) => this.handleEnableCategoryViewsToggle(code, value)}
                                            value={this.props.currentConfigCopy.inContextEnableCategoryViews}
                                        />
                                        {this.props.currentConfigCopy.inContextEnableCategoryViews && (
                                            <div>
                                                <ConfigurationCheckbox
                                                    title="Exclude room category images from room image galleries"
                                                    isDisabled={this.props.isDisabled}
                                                    code="inContextExcludeRoomCategoryImagesFromImageGalleries"
                                                    onChange={this.props.toggleConfigBoolean}
                                                    value={this.props.currentConfigCopy.inContextExcludeRoomCategoryImagesFromImageGalleries}
                                                />
                                                <ReactSparkSelectInput
                                                    className="top-margin"
                                                    label="Room display in category view"
                                                    defaultValue={this.props.currentConfigCopy.inContextRoomCategoryViewOption}
                                                    values={inContextRoomCategoryViewOption}
                                                    onChange={event => {
                                                        this.props.setConfigText('inContextRoomCategoryViewOption', event.target.value);
                                                    }}
                                                    isDisabled={this.props.isDisabled}
                                                />
                                                {this.props.currentConfigCopy.inContextRoomCategoryViewOption === 'showRoomsGrouping' && (
                                                    <ReactSparkSelectInput
                                                        className="top-margin"
                                                        label="Category expand option"
                                                        defaultValue={this.props.currentConfigCopy.inContextRoomCategoryExpandOption}
                                                        values={inContextRoomCategoryExpandOption}
                                                        onChange={event => {
                                                            this.props.setConfigText('inContextRoomCategoryExpandOption', event.target.value);
                                                        }}
                                                        isDisabled={this.props.isDisabled}
                                                    />
                                                )}
                                            </div>
                                        )}
                                    </div>
                                )}

                                <hr />
                                <h4 className="subHeading__in">
                                    <span>In-context: location for <span className="bold-italic">resume booking</span> button</span>
                                    <span onClick={() => this.handleClickOnInfoIcon('resumeBookingDistance')} className="spark-icon spark-icon-info-circle productViewHelpIcon" />
                                </h4>
                                <InContextPositionDistanceControl
                                    currentConfigCopy={this.props.currentConfigCopy}
                                    setConfigText={this.props.setConfigText}
                                    setConfigNumber={this.props.setConfigNumber}
                                    isDisabled={this.props.isDisabled}
                                />
                                <hr />
                                <h4 className="top-margin">In-context: overlay position (for desktop screens)</h4>
                                <div className="defaultProductViewRadioButtonGroup">
                                    <SparkRadioButton
                                        name="in-context-overlay-width"
                                        value="fullPage"
                                        checked={this.state.overlayWidthRadioButton === 'fullPage'}
                                        onClick={event => this.handleOverlayWidthChange(event)}
                                        disabled={this.props.isDisabled}
                                    >
                                        {IN_CONTEXT_OVERLAY_WIDTH.FULL_PAGE}
                                    </SparkRadioButton>
                                    <SparkRadioButton
                                        name="in-context-overlay-width"
                                        value="tabletSize"
                                        checked={this.state.overlayWidthRadioButton === 'tabletSize'}
                                        onClick={event => this.handleOverlayWidthChange(event)}
                                        disabled={this.props.isDisabled}
                                    >
                                        {IN_CONTEXT_OVERLAY_WIDTH.TABLET_SIZE}
                                    </SparkRadioButton>
                                </div>
                            </div>
                        </If>
                        <div className="subHeading">
                            <div>Default display</div>
                            <div className="defaultProductViewRadioButtonGroup">
                                <SparkRadioButton
                                    name="split-view-room"
                                    value="splitView-room"
                                    checked={this.state.productViewRadioButton === 'splitView' && this.state.splitViewRadioButton === 'room'}
                                    onClick={event => this.handleDefaultSplitViewOnClick(event)}
                                    disabled={this.props.isDisabled}
                                >
                                    {PRODUCT_LAYOUT_VIEWS.SPLIT_VIEW_ROOMS}
                                </SparkRadioButton>
                                <SparkRadioButton
                                    name="split-view-rates"
                                    value="splitView-rate"
                                    checked={this.state.productViewRadioButton === 'splitView' && this.state.splitViewRadioButton === 'rate'}
                                    onClick={event => this.handleDefaultSplitViewOnClick(event)}
                                    disabled={this.props.isDisabled}
                                >
                                    {PRODUCT_LAYOUT_VIEWS.SPLIT_VIEW_RATES}
                                </SparkRadioButton>
                                <SparkRadioButton
                                    name="list-view"
                                    value="listView"
                                    checked={this.state.productViewRadioButton === 'listView'}
                                    onClick={event => this.handleProductViewOnCick(event)}
                                    disabled={this.props.isDisabled}
                                >
                                    {PRODUCT_LAYOUT_VIEWS.LIST_VIEW}
                                </SparkRadioButton>
                                <SparkRadioButton
                                    name="card-view"
                                    value="cardView"
                                    checked={this.state.productViewRadioButton === 'cardView'}
                                    onClick={event => this.handleProductViewOnCick(event)}
                                    disabled={this.props.isDisabled}
                                >
                                    {PRODUCT_LAYOUT_VIEWS.GRID_VIEW}
                                </SparkRadioButton>
                            </div>
                        </div>
                        {this.props.currentConfigCopy.defaultProductView === 'splitView' && (
                            <ReactSparkSelectInput
                                label="Number of products to expand"
                                isDisabled={this.props.isDisabled}
                                defaultValue={splitViewExpandOptionDefault.key}
                                values={splitViewExpandOption}
                                onChange={event => {
                                    const obj = splitViewExpandOption.find(elem => elem.key === event.target.value);
                                    this.props.setConfigText('splitViewExpandOption', obj.key);
                                }}
                            />
                        )}
                        <ReactSparkSelectInput
                            label="Toggle option settings"
                            isDisabled={this.props.isDisabled}
                            defaultValue={defaultValueForLayoutViewSettings.key}
                            values={layoutViewSettings.map(v => ({ key: v.key, label: v.label }))}
                            onChange={event => {
                                const obj = layoutViewSettings.find(elem => elem.key === event.target.value);
                                this.props.setConfigText('layoutViewSetting', obj.key);
                            }}
                        />
                    </div>
                </section>
                <section
                    ref={this.registerSection(1)}
                    style={
                        this.props.currentConfigCopy.defaultProductView !== 'splitView' ||
                        (this.props.searchIndex !== undefined && this.props.searchIndex.indexOf(1) === -1)
                            ? { display: 'none' }
                            : {}
                    }
                >
                    <div className={classnames('layoutViewSettingsSection', 'spark-panel__content col-lg-12')}>
                        <div className="spark-mar-l-1">
                            <ConfigurationCheckbox
                                title="Show rate image"
                                isDisabled={this.props.isDisabled}
                                code="showRateImage"
                                onChange={this.props.toggleConfigBoolean}
                                value={this.props.currentConfigCopy.showRateImage}
                            />
                            <ConfigurationCheckbox
                                title="Show price summary"
                                isDisabled={this.props.isDisabled}
                                code="showPriceSummary"
                                onChange={this.props.toggleConfigBoolean}
                                value={this.props.currentConfigCopy.showPriceSummary}
                            />
                        </div>
                    </div>
                    <section ref={this.registerSection(2)} style={this.sectionStyleHandler(2)}>
                        <h4>Room Category Settings</h4>
                        <div className="spark-panel__content col-lg-12">
                            <ConfigurationCheckbox
                                title="Display Room Categories"
                                isDisabled={this.props.isDisabled}
                                code="showRoomCategories"
                                onChange={this.props.toggleConfigBoolean}
                                value={this.props.currentConfigCopy.showRoomCategories}
                            />
                            {this.props.currentConfigCopy.showRoomCategories && (
                                <div className="spark-panel__content col-lg-12">
                                    <ConfigurationCheckbox
                                        title="Display Room Category Banner Image"
                                        isDisabled={this.props.isDisabled}
                                        code="enableRoomCategoryImages"
                                        onChange={this.props.toggleConfigBoolean}
                                        value={this.props.currentConfigCopy.enableRoomCategoryImages}
                                    />
                                    <ConfigurationCheckbox
                                        title="Exclude Room Category Images from Room Image Galleries"
                                        isDisabled={this.props.isDisabled}
                                        code="excludeRoomCategoryImagesFromImageGalleries"
                                        onChange={this.props.toggleConfigBoolean}
                                        value={this.props.currentConfigCopy.excludeRoomCategoryImagesFromImageGalleries}
                                    />
                                    <ConfigurationCheckbox
                                        title="Filter Categories With Exact Match"
                                        isDisabled={this.props.isDisabled}
                                        code="roomCategoriesExactMatch"
                                        onChange={this.props.toggleConfigBoolean}
                                        value={this.props.currentConfigCopy.roomCategoriesExactMatch}
                                    />
                                    <ReactSparkSelectInput
                                        label="Room Category Expand Option"
                                        isDisabled={this.props.isDisabled}
                                        defaultValue={this.props.currentConfigCopy.roomCategoryExpandOption}
                                        values={roomCategoryExpandOption}
                                        onChange={e => {
                                            this.props.setConfigText('roomCategoryExpandOption', e.target.value);
                                        }}
                                    />
                                    <ReactSparkSelectInput
                                        label="Room Display in Category View"
                                        isDisabled={this.props.isDisabled}
                                        defaultValue={this.props.currentConfigCopy.roomCategoryViewOption}
                                        values={roomCategoryViewOption}
                                        onChange={e => {
                                            this.props.setConfigText('roomCategoryViewOption', e.target.value);
                                        }}
                                    />
                                </div>
                            )}
                        </div>
                    </section>
                </section>
                <h4>Shopping Cart (Stay Summary) Expiration</h4>
                <div>
                    The booking engine automatically saves guests' selected items for future visits. Upon return, guests
                    are prompted to book or ignore saved items.
                </div>
                <div className="spark-panel__content col-lg-12">
                    <ConfigurationCheckbox
                        title={`Allow guests to resume bookings (shows "cart" when guest returns)`}
                        isDisabled={this.props.isDisabled}
                        code="resumeBookings"
                        onChange={this.props.toggleConfigBoolean}
                        value={this.props.currentConfigCopy.resumeBookings}
                    />
                    {this.props.currentConfigCopy.resumeBookings && (
                        <ReactSparkSelectInput
                            label="Keep items for guests"
                            isDisabled={this.props.isDisabled}
                            defaultValue={resumeCartExpirationDaysDefault.key}
                            values={shoppingCartExpirationDays}
                            onChange={e => {
                                this.props.setConfigNumber('shoppingCartExpirationDays', e.target.value);
                            }}
                        />
                    )}
                </div>
                <h4
                    style={
                        this.props.searchIndex !== undefined &&
                        this.props.searchIndex.indexOf(2) === -1 &&
                        this.props.searchIndex.indexOf(4) === -1 &&
                        this.props.searchIndex.indexOf(5) === -1
                            ? { display: 'none' }
                            : {}
                    }
                >
                    Urgency Trigger Settings
                </h4>
                <div className="spark-panel__content col-lg-12">
                    <section ref={this.registerSection(3)} style={this.sectionStyleHandler(3)}>
                        <h4>Room Urgency Triggers</h4>
                        <ConfigurationCheckbox
                            title="Enable Urgency Trigger for Rooms"
                            isDisabled={this.props.isDisabled}
                            code="enableUrgencyTriggerForRooms"
                            onChange={this.props.toggleConfigBoolean}
                            value={this.props.currentConfigCopy.enableUrgencyTriggerForRooms}
                        />
                        <div
                            style={this.props.currentConfigCopy.enableUrgencyTriggerForRooms ? {} : { display: 'none' }}
                        >
                            <ConfigurationCheckbox
                                title="Number of Bookings"
                                isDisabled={this.props.isDisabled}
                                code="configThresholdUrgencyTriggersForRooms.NoOfBookings.Enabled"
                                onChange={this.props.toggleConfigBoolean}
                                value={
                                    this.props.currentConfigCopy.configThresholdUrgencyTriggersForRooms.NoOfBookings
                                        .Enabled
                                }
                            />
                            <div className="spark-panel__content col-lg-12">
                                <ReactSparkSelectInput
                                    label="Number of Bookings"
                                    isDisabled={this.props.isDisabled}
                                    defaultValue={
                                        this.props.currentConfigCopy.configThresholdUrgencyTriggersForRooms.NoOfBookings
                                            .Value
                                    }
                                    values={range(101).map(v => {
                                        return { key: v, label: v };
                                    })}
                                    onChange={event => {
                                        this.props.setConfigNumber(
                                            'configThresholdUrgencyTriggersForRooms.NoOfBookings.Value',
                                            event.target.value
                                        );
                                    }}
                                />
                            </div>
                            <ConfigurationCheckbox
                                title="Number of Viewers"
                                isDisabled={this.props.isDisabled}
                                code="configThresholdUrgencyTriggersForRooms.NoOfOnlookers.Enabled"
                                onChange={this.props.toggleConfigBoolean}
                                value={
                                    this.props.currentConfigCopy.configThresholdUrgencyTriggersForRooms.NoOfOnlookers
                                        .Enabled
                                }
                            />
                            <div className="spark-panel__content col-lg-12">
                                <ReactSparkSelectInput
                                    label="Number of Viewers"
                                    isDisabled={this.props.isDisabled}
                                    defaultValue={
                                        this.props.currentConfigCopy.configThresholdUrgencyTriggersForRooms
                                            .NoOfOnlookers.Value
                                    }
                                    values={range(101).map(v => {
                                        return { key: v, label: v };
                                    })}
                                    onChange={event => {
                                        this.props.setConfigNumber(
                                            'configThresholdUrgencyTriggersForRooms.NoOfOnlookers.Value',
                                            event.target.value
                                        );
                                    }}
                                />
                            </div>
                            <ConfigurationCheckbox
                                title="Time Elapsed Since Last Booking"
                                isDisabled={this.props.isDisabled}
                                code="configThresholdUrgencyTriggersForRooms.TimeElapsedSinceLastBooking.Enabled"
                                onChange={this.props.toggleConfigBoolean}
                                value={
                                    this.props.currentConfigCopy.configThresholdUrgencyTriggersForRooms
                                        .TimeElapsedSinceLastBooking.Enabled
                                }
                            />
                            <div className="spark-panel__content col-lg-12">
                                <ReactSparkSelectInput
                                    label="Time Elapsed Since Last Booking"
                                    isDisabled={this.props.isDisabled}
                                    defaultValue={
                                        this.props.currentConfigCopy.configThresholdUrgencyTriggersForRooms
                                            .TimeElapsedSinceLastBooking.Value
                                    }
                                    values={['12:00', '18:00', '24:00', '36:00', '48:00', '72:00'].map(v => {
                                        return { key: v, label: v };
                                    })}
                                    onChange={event => {
                                        this.props.setConfigText(
                                            'configThresholdUrgencyTriggersForRooms.TimeElapsedSinceLastBooking.Value',
                                            event.target.value
                                        );
                                    }}
                                />
                            </div>
                            <ConfigurationCheckbox
                                title="In High Demand"
                                isDisabled={this.props.isDisabled}
                                code="configThresholdUrgencyTriggersForRooms.InHighDemand.Enabled"
                                onChange={this.props.toggleConfigBoolean}
                                value={get(
                                    this.props.currentConfigCopy,
                                    'configThresholdUrgencyTriggersForRooms.InHighDemand.Enabled'
                                )}
                            />
                            <div className="spark-panel__content col-lg-12">
                                <ReactSparkSelectInput
                                    label="In High Demand"
                                    isDisabled={this.props.isDisabled}
                                    defaultValue={get(
                                        this.props,
                                        'currentConfigCopy.configThresholdUrgencyTriggersForRooms.InHighDemand.Value'
                                    )}
                                    values={range(61).map(v => {
                                        return { key: v, label: v };
                                    })}
                                    onChange={event => {
                                        this.props.setConfigNumber(
                                            'configThresholdUrgencyTriggersForRooms.InHighDemand.Value',
                                            event.target.value
                                        );
                                    }}
                                />
                            </div>
                        </div>
                    </section>
                    <section ref={this.registerSection(4)} style={this.sectionStyleHandler(4)}>
                        <h4>Hotel Urgency Triggers</h4>
                        <ConfigurationCheckbox
                            title="Enable Urgency Triggers for Hotels"
                            isDisabled={this.props.isDisabled}
                            code="enableUrgencyTriggerForHotelLevel"
                            onChange={this.props.toggleConfigBoolean}
                            value={this.props.currentConfigCopy.enableUrgencyTriggerForHotelLevel}
                        />
                        {this.props.currentConfigCopy.enableUrgencyTriggerForHotelLevel && (
                            <div>
                                <ConfigurationCheckbox
                                    title="Enabled"
                                    isDisabled={this.props.isDisabled}
                                    code="configThresholdUrgencyTriggersForHotel.NoOfRemainingRooms.Enabled"
                                    onChange={this.props.toggleConfigBoolean}
                                    value={
                                        this.props.currentConfigCopy.configThresholdUrgencyTriggersForHotel
                                            .NoOfRemainingRooms.Enabled
                                    }
                                />
                                <div className="spark-panel__content col-lg-12">
                                    <ReactSparkSelectInput
                                        label="Number of Rooms"
                                        isDisabled={this.props.isDisabled}
                                        defaultValue={
                                            this.props.currentConfigCopy.configThresholdUrgencyTriggersForHotel
                                                .NoOfRemainingRooms.Value
                                        }
                                        values={range(61).map(v => {
                                            return { key: v, label: v };
                                        })}
                                        onChange={event => {
                                            this.props.setConfigNumber(
                                                'configThresholdUrgencyTriggersForHotel.NoOfRemainingRooms.Value',
                                                event.target.value
                                            );
                                        }}
                                    />
                                </div>
                                <ConfigurationCheckbox
                                    title="Enabled"
                                    isDisabled={this.props.isDisabled}
                                    code="configThresholdUrgencyTriggersForHotel.NoOfBookings.Enabled"
                                    onChange={this.props.toggleConfigBoolean}
                                    value={
                                        this.props.currentConfigCopy.configThresholdUrgencyTriggersForHotel.NoOfBookings
                                            .Enabled
                                    }
                                />
                                <div className="spark-panel__content col-lg-12">
                                    <ReactSparkSelectInput
                                        label="Number of Bookings"
                                        isDisabled={this.props.isDisabled}
                                        defaultValue={
                                            this.props.currentConfigCopy.configThresholdUrgencyTriggersForHotel
                                                .NoOfBookings.Value
                                        }
                                        values={range(101).map(v => {
                                            return { key: v, label: v };
                                        })}
                                        onChange={event => {
                                            this.props.setConfigNumber(
                                                'configThresholdUrgencyTriggersForHotel.NoOfBookings.Value',
                                                event.target.value
                                            );
                                        }}
                                    />
                                </div>
                                <ConfigurationCheckbox
                                    title="Enabled"
                                    isDisabled={this.props.isDisabled}
                                    code="configThresholdUrgencyTriggersForHotel.NoOfOnlookers.Enabled"
                                    onChange={this.props.toggleConfigBoolean}
                                    value={
                                        this.props.currentConfigCopy.configThresholdUrgencyTriggersForHotel
                                            .NoOfOnlookers.Enabled
                                    }
                                />
                                <div className="spark-panel__content col-lg-12">
                                    <ReactSparkSelectInput
                                        label="Number of Viewers"
                                        isDisabled={this.props.isDisabled}
                                        defaultValue={
                                            this.props.currentConfigCopy.configThresholdUrgencyTriggersForHotel
                                                .NoOfOnlookers.Value
                                        }
                                        values={range(101).map(v => {
                                            return { key: v, label: v };
                                        })}
                                        onChange={event => {
                                            this.props.setConfigNumber(
                                                'configThresholdUrgencyTriggersForHotel.NoOfOnlookers.Value',
                                                event.target.value
                                            );
                                        }}
                                    />
                                </div>
                                <ConfigurationCheckbox
                                    title="Enabled"
                                    isDisabled={this.props.isDisabled}
                                    code="configThresholdUrgencyTriggersForHotel.TimeElapsedSinceLastBooking.Enabled"
                                    onChange={this.props.toggleConfigBoolean}
                                    value={
                                        this.props.currentConfigCopy.configThresholdUrgencyTriggersForHotel
                                            .TimeElapsedSinceLastBooking.Enabled
                                    }
                                />
                                <div className="spark-panel__content col-lg-12">
                                    <ReactSparkSelectInput
                                        label="Time Elapsed Since Last Booking"
                                        isDisabled={this.props.isDisabled}
                                        defaultValue={
                                            this.props.currentConfigCopy.configThresholdUrgencyTriggersForHotel
                                                .TimeElapsedSinceLastBooking.Value
                                        }
                                        values={['12:00', '18:00', '24:00', '36:00', '48:00', '72:00'].map(v => {
                                            return { key: v, label: v };
                                        })}
                                        onChange={event => {
                                            this.props.setConfigText(
                                                'configThresholdUrgencyTriggersForHotel.TimeElapsedSinceLastBooking.Value',
                                                event.target.value
                                            );
                                        }}
                                    />
                                </div>
                            </div>
                        )}
                    </section>
                    <section ref={this.registerSection(5)} style={this.sectionStyleHandler(5)}>
                        <h4>Chain Urgency Triggers</h4>
                        <ConfigurationCheckbox
                            title="Enable Urgency Triggers for Hotels"
                            isDisabled={this.props.isDisabled}
                            code="enableUrgencyTriggerForHotels"
                            onChange={this.props.toggleConfigBoolean}
                            value={this.props.currentConfigCopy.enableUrgencyTriggerForHotels}
                        />
                        {this.props.currentConfigCopy.enableUrgencyTriggerForHotels && (
                            <div>
                                <ConfigurationCheckbox
                                    title="Enabled"
                                    isDisabled={this.props.isDisabled}
                                    code="configThresholdUrgencyTriggersForChain.NoOfRemainingRooms.Enabled"
                                    onChange={this.props.toggleConfigBoolean}
                                    value={
                                        this.props.currentConfigCopy.configThresholdUrgencyTriggersForChain
                                            .NoOfRemainingRooms.Enabled
                                    }
                                />
                                <div className="spark-panel__content col-lg-12">
                                    <ReactSparkSelectInput
                                        label="Number of Rooms"
                                        isDisabled={this.props.isDisabled}
                                        defaultValue={
                                            this.props.currentConfigCopy.configThresholdUrgencyTriggersForChain
                                                .NoOfRemainingRooms.Value
                                        }
                                        values={range(61).map(v => {
                                            return { key: v, label: v };
                                        })}
                                        onChange={event => {
                                            this.props.setConfigNumber(
                                                'configThresholdUrgencyTriggersForChain.NoOfRemainingRooms.Value',
                                                event.target.value
                                            );
                                        }}
                                    />
                                </div>
                                <ConfigurationCheckbox
                                    title="Enabled"
                                    isDisabled={this.props.isDisabled}
                                    code="configThresholdUrgencyTriggersForChain.NoOfBookings.Enabled"
                                    onChange={this.props.toggleConfigBoolean}
                                    value={
                                        this.props.currentConfigCopy.configThresholdUrgencyTriggersForChain.NoOfBookings
                                            .Enabled
                                    }
                                />
                                <div className="spark-panel__content col-lg-12">
                                    <ReactSparkSelectInput
                                        label="Number of Bookings"
                                        isDisabled={this.props.isDisabled}
                                        defaultValue={
                                            this.props.currentConfigCopy.configThresholdUrgencyTriggersForChain
                                                .NoOfBookings.Value
                                        }
                                        values={range(101).map(v => {
                                            return { key: v, label: v };
                                        })}
                                        onChange={event => {
                                            this.props.setConfigNumber(
                                                'configThresholdUrgencyTriggersForChain.NoOfBookings.Value',
                                                event.target.value
                                            );
                                        }}
                                    />
                                </div>
                                <ConfigurationCheckbox
                                    title="Enabled"
                                    isDisabled={this.props.isDisabled}
                                    code="configThresholdUrgencyTriggersForChain.NoOfOnlookers.Enabled"
                                    onChange={this.props.toggleConfigBoolean}
                                    value={
                                        this.props.currentConfigCopy.configThresholdUrgencyTriggersForChain
                                            .NoOfOnlookers.Enabled
                                    }
                                />
                                <div className="spark-panel__content col-lg-12">
                                    <ReactSparkSelectInput
                                        label="Number of Viewers"
                                        isDisabled={this.props.isDisabled}
                                        defaultValue={
                                            this.props.currentConfigCopy.configThresholdUrgencyTriggersForChain
                                                .NoOfOnlookers.Value
                                        }
                                        values={range(101).map(v => {
                                            return { key: v, label: v };
                                        })}
                                        onChange={event => {
                                            this.props.setConfigNumber(
                                                'configThresholdUrgencyTriggersForChain.NoOfOnlookers.Value',
                                                event.target.value
                                            );
                                        }}
                                    />
                                </div>
                                <ConfigurationCheckbox
                                    title="Enabled"
                                    isDisabled={this.props.isDisabled}
                                    code="configThresholdUrgencyTriggersForChain.TimeElapsedSinceLastBooking.Enabled"
                                    onChange={this.props.toggleConfigBoolean}
                                    value={
                                        this.props.currentConfigCopy.configThresholdUrgencyTriggersForChain
                                            .TimeElapsedSinceLastBooking.Enabled
                                    }
                                />
                                <div className="spark-panel__content col-lg-12">
                                    <ReactSparkSelectInput
                                        label="Time Elapsed Since Last Booking"
                                        isDisabled={this.props.isDisabled}
                                        defaultValue={
                                            this.props.currentConfigCopy.configThresholdUrgencyTriggersForChain
                                                .TimeElapsedSinceLastBooking.Value
                                        }
                                        values={['12:00', '18:00', '24:00', '36:00', '48:00', '72:00'].map(v => {
                                            return { key: v, label: v };
                                        })}
                                        onChange={event => {
                                            this.props.setConfigText(
                                                'configThresholdUrgencyTriggersForChain.TimeElapsedSinceLastBooking.Value',
                                                event.target.value
                                            );
                                        }}
                                    />
                                </div>
                                <h4> Reference Time Frame</h4>
                                <div className="spark-panel__content col-lg-12">
                                    <ReactSparkSelectInput
                                        label="Reference Time Frame"
                                        isDisabled={this.props.isDisabled}
                                        defaultValue={
                                            this.props.currentConfigCopy.urgencyTriggersTimePeriod.TimePeriod.Hours
                                        }
                                        values={[12, 18, 24, 36, 48, 72].map(v => {
                                            return { key: v, label: v };
                                        })}
                                        onChange={event => {
                                            this.props.setConfigNumber(
                                                'urgencyTriggersTimePeriod.TimePeriod.Hours',
                                                event.target.value
                                            );
                                        }}
                                    />
                                </div>
                            </div>
                        )}
                    </section>
                </div>
                <section ref={this.registerSection(6)} style={this.sectionStyleHandler(6)}>
                    <h4>Video Settings</h4>
                    <ConfigurationCheckbox
                        title="Enable Videos"
                        code="videoEnable"
                        isDisabled={this.props.isDisabled}
                        onChange={this.props.toggleConfigBoolean}
                        value={this.props.currentConfigCopy.videoEnable}
                    />
                    {this.props.currentConfigCopy.videoEnable && (
                        <div className="spark-panel__content col-lg-12">
                            <ConfigManage
                                list={this.props.currentConfigCopy.videoPaths}
                                isDisabled={this.props.isDisabled}
                                addConfigRow={this.props.addConfigRow}
                                editConfigRow={this.props.editConfigRow}
                                deleteConfigRow={this.props.deleteConfigRow}
                                firstColumn="Room Code"
                                secondColumn="Video URL"
                            />
                        </div>
                    )}
                </section>
                <section ref={this.registerSection(7)} style={this.sectionStyleHandler(7)}>
                    <h4>Geo Promotions</h4>
                    <h6>
                        Turn location permission prompt on only if hotel offers special rates based on the guest's
                        physical location.
                    </h6>
                    <div className="spark-panel__content col-lg-12">
                        <ConfigurationCheckbox
                            title="Allow browser to ask for location when products are shown"
                            isDisabled={this.props.isDisabled}
                            code="isGeoPromotionEnabled"
                            onChange={this.props.toggleConfigBoolean}
                            value={this.props.currentConfigCopy.isGeoPromotionEnabled}
                        />
                    </div>
                </section>
                <section ref={this.registerSection(7)} style={this.sectionStyleHandler(7)}>
                    <h4>Third-party Widgets</h4>
                    <div className="spark-panel__content col-lg-12">
                        <ConfigurationCheckbox
                            title="Enable Triptease Price Check Lite"
                            isDisabled={this.props.isDisabled}
                            code="enableTripteasePriceCheckLite"
                            onChange={this.props.toggleConfigBoolean}
                            value={this.props.currentConfigCopy.enableTripteasePriceCheckLite}
                        />
                    </div>
                </section>
            </div>
        );
    }
}

RoomsConfiguration.propTypes = {
    children: PropTypes.element
};

export default RoomsConfiguration;



// WEBPACK FOOTER //
// ./src/components/pages/pages/RoomsConfiguration.js